import Vue from "vue";
import VueMaterial from "vue-material";

import VueMaterialPatch from "lib/plugins/VueMaterialPatch";
import Notification from "lib/components/Notification";
import WebPlayerLivePage from "components/WebPlayerLivePage";
import cookie from "lib/modules/Cookie";
import cssVars from "lib/modules/CssVars";

cssVars.init();

window.$bus = new Vue();

Vue.use(VueMaterial);
Vue.use(VueMaterialPatch);

new Vue({
	el: "#notification",
	mounted() {
		cookie.checkConsent();
	},
	render(h) {
		return h(Notification);
	}
});

new Vue({
	el: "#live-container",
	beforeMount() {
		this.id = this.$el.dataset.id;
	},
	render(h) {
		return h(WebPlayerLivePage, { props: { id: this.id } });
	}
});
